var swiper = new Swiper(".content-slider-testimonials", {
  slidesPerView: 1.05, // En móvil muestra 1 slide completa + 20px de la siguiente
  spaceBetween: 10,
  // NOTE: This slider navigates with arrows only; it has no pagination element
  // of its own. A `pagination: { el: ".swiper-pagination" }` config here would
  // resolve to the first .swiper-pagination in the document (the bioactive hero
  // slider at the top of the page) and render this slider's bullets into it,
  // breaking that slider's pagination. Do not add a pagination block.
  navigation: {
    nextEl: ".arrow-button.arrow-next",
    prevEl: ".arrow-button.arrow-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  a11y: {
    prevSlideMessage: 'Previous testimonial',
    nextSlideMessage: 'Next testimonial',
    firstSlideMessage: 'This is the first testimonial',
    lastSlideMessage: 'This is the last testimonial',
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
      spaceBetween: 20,
    },
  },
  // Prevenir que Swiper se active con clicks en elementos específicos
  preventInteractionOnTransition: true,
});

document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(
    ".section-testimonials .content-video"
  );

  videos.forEach((container) => {
    const video = /** @type {HTMLVideoElement | null} */ (container.querySelector("video"));
    const playBtn = /** @type {HTMLElement | null} */ (container.querySelector(".video-play-btn"));
    const poster = /** @type {HTMLElement | null} */ (container.querySelector(".video-poster"));
    let pausePosterTimeout = /** @type {ReturnType<typeof setTimeout> | null} */ (null);
    let ignoreNextPause = false;

    if (video) {
      // Bloquear Swiper cuando el mouse está sobre el video o controles
      const disableSwiper = () => {
        swiper.allowTouchMove = false;
        swiper.allowSlideNext = false;
        swiper.allowSlidePrev = false;
      };
      
      const enableSwiper = () => {
        swiper.allowTouchMove = true;
        swiper.allowSlideNext = true;
        swiper.allowSlidePrev = true;
      };

      // Aplicar a todos los elementos interactivos del video
      const videoElements = [video, playBtn, poster].filter(el => el);
      
      videoElements.forEach(el => {
        if (el) {
          // Cuando el mouse entra en el área del video
          el.addEventListener('mouseenter', disableSwiper);
          el.addEventListener('touchstart', disableSwiper);
          
          // Cuando el mouse sale del área del video
          el.addEventListener('mouseleave', enableSwiper);
          el.addEventListener('touchend', enableSwiper);
        }
      });

      const clearPauseTimeout = () => {
        if (pausePosterTimeout) {
          clearTimeout(pausePosterTimeout);
          pausePosterTimeout = null;
        }
      };

      video.addEventListener('pointerdown', (event) => {
        if (!video.controls) {
          ignoreNextPause = false;
          return;
        }

        const rect = video.getBoundingClientRect();
        const pointerY = event.clientY - rect.top;
        const controlZoneHeight = Math.min(80, rect.height * 0.35);
        const inControlZone = pointerY >= rect.height - controlZoneHeight;

        ignoreNextPause = !inControlZone;
      });

      // Play manual
      if (playBtn) {
        playBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault(); // Importante: prevenir el comportamiento por defecto

          openVideoLightbox(video);
        });
      }

      const showPosterAndButton = () => {
        if (poster) {
          poster.style.display = "flex";
        }
        if (playBtn) {
          playBtn.style.display = "block";
        }
      };

      const hidePosterAndButton = () => {
        if (poster) {
          poster.style.display = "none";
        }
        if (playBtn) {
          playBtn.style.display = "none";
        }
      };

      video.addEventListener('play', () => {
        clearPauseTimeout();
        hidePosterAndButton();
        swiper.allowTouchMove = false;
        swiper.allowSlideNext = false;
        swiper.allowSlidePrev = false;
        ignoreNextPause = false;
      });

      video.addEventListener('pause', () => {
        clearPauseTimeout();

        if (ignoreNextPause) {
          ignoreNextPause = false;
          const resumePromise = video.play();
          if (resumePromise && typeof resumePromise.catch === "function") {
            resumePromise.catch(() => {});
          }
          return;
        }

        pausePosterTimeout = setTimeout(() => {
          if (!video.paused || video.seeking) {
            return;
          }

          showPosterAndButton();

          const isInteracting = video.matches(':hover') ||
            video.matches(':active') ||
            (playBtn && playBtn.matches(':hover'));

          if (!isInteracting) {
            swiper.allowTouchMove = true;
            swiper.allowSlideNext = true;
            swiper.allowSlidePrev = true;
          }
        }, 150);
      });

      video.addEventListener('ended', () => {
        clearPauseTimeout();
        showPosterAndButton();
        swiper.allowTouchMove = true;
        swiper.allowSlideNext = true;
        swiper.allowSlidePrev = true;
        ignoreNextPause = false;
      });
    }
  });

  function openVideoLightbox(originalVideo) {
    const lightbox = document.getElementById('video-lightbox');
    const lightboxContent = lightbox.querySelector('.video-lightbox__content');
    
    if (!lightbox || !lightboxContent) return;

    const videoClone = originalVideo.cloneNode(true);
    
    videoClone.controls = true;
    videoClone.autoplay = true;
    videoClone.muted = false;
    videoClone.style.width = '100%';
    videoClone.style.height = '100%';
    
    lightboxContent.innerHTML = '';
    lightboxContent.appendChild(videoClone);
    
    lightbox.style.display = 'flex';
    setTimeout(() => {
      lightbox.classList.add('active');
    }, 10);
    
    document.body.style.overflow = 'hidden';
    
    videoClone.play().catch(console.error);
  }

  function closeVideoLightbox() {
    const lightbox = document.getElementById('video-lightbox');
    const lightboxContent = lightbox.querySelector('.video-lightbox__content');
    
    if (!lightbox) return;

    const video = lightboxContent.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    
    lightbox.classList.remove('active');
    
    setTimeout(() => {
      lightbox.style.display = 'none';
      lightboxContent.innerHTML = '';
    }, 300);
    
    document.body.style.overflow = '';
  }

  const lightbox = document.getElementById('video-lightbox');
  if (lightbox) {
    const closeBtn = lightbox.querySelector('.video-lightbox__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeVideoLightbox);
    }
    
    const backdrop = lightbox.querySelector('.video-lightbox__backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', closeVideoLightbox);
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.classList.contains('active')) {
        closeVideoLightbox();
      }
    });
  }
});